<app-admin-header
  style="width: 100%"
  [header]="header"
  [links]="links"
  [breadcrumbs]="breadcrumbs"
  [stats]="stats"
  [queryParams]="queryParams"
></app-admin-header>
<div class="w-100">
  <!-- skelition   -->
  <app-skelitions
    [hidden]="!skelition"
    [value]="2"
    class="mb-2"
  ></app-skelitions>
</div>
<p-toast />
<section class="container-fluid ms-main-bg py-5" *ngIf="!skelition">
  <div class="container ms-pg-structure">
    <div class="d-flex-between-mob-column" #scrollTarget>
      <div>
        <h4 class="large-h">
          {{ (isEdit ? "Update Vendor" : "Create Vendor") | translator }}
        </h4>
      </div>
    </div>

    <div class="white-box">
      <p-messages [(value)]="messages" [enableService]="false"></p-messages>
      <div class="row my-4">
        <!-- Name -->
        <div class="col-md-4 col-12">
          <div class="column mx-4 my-2">
            <h5 class="medium-h">{{ (classification == 'internal' ? "Internal Branch": "Company Name") | translator }}</h5>
            <input
              type="text"
              class="form-control ms-input"
              placeholder="{{(classification == 'internal' ? 'Internal Branch': 'Company Name')| translator }}"
              id="nameInput"
              aria-describedby="emailHelp"
              [(ngModel)]="companyName"
            />
          </div>
        </div>
        <!-- Location -->
        <div class="col-md-4 col-12">
          <div class="column mx-4 my-2">
            <h5 class="medium-h">{{ "Ms Location" | translator }}</h5>
            <p-dropdown
              id="city"
              [options]="city"
              [placeholder]="
                isEdit ? selectedLocation : ('Select city' | translator)
              "
              [(ngModel)]="location"
              styleClass=" sstarabic w-100"
            >
              <ng-template let-item pTemplate="item">
                <i [ngClass]="item.icon"></i>
                {{ item.label }}
              </ng-template>
            </p-dropdown>
          </div>
        </div>
        <!-- Classification -->
        <div class="col-md-4 col-12">
          <div class="column mx-4 my-2">
            <h5 class="medium-h">{{ "Classification" | translator }}</h5>
            <div class="d-flex">
              <div
                (click)="classification = 'internal'"
                [class.classification-btn-active]="
                  classification === 'internal'
                "
                [class.classification-btn-Dactive]="
                  classification !== 'internal'
                "
              >
                <label> {{ "Ms Internal" | translator }} </label>
              </div>
              &nbsp;
              <div
                (click)="classification = 'external'"
                [class.classification-btn-active]="
                  classification === 'external'
                "
                [class.classification-btn-Dactive]="
                  classification !== 'external'
                "
              >
                <label> {{ "Ms External" | translator }} </label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Vendor Details -->
      <div class="row my-4">
        <!-- PM Name -->
        <div class="col-md-4 col-12">
          <div class="column mx-4 my-2">
            <h5 class="medium-h">{{ "PM Name" | translator }}</h5>
            <input
              type="text"
              class="form-control ms-input"
              [placeholder]="'PM Name' | translator"
              id="pmNameInput"
              aria-describedby="emailHelp"
              [(ngModel)]="pmName"
            />
          </div>
        </div>
        <!-- PM Email -->
        <div class="col-md-4 col-12">
          <div class="column mx-4 my-2">
            <h5 class="medium-h">{{ "PM Email" | translator }}</h5>
            <input
              type="text"
              class="form-control ms-input"
              [placeholder]="'PM Email' | translator"
              id="pmEmailInput"
              aria-describedby="emailHelp"
              [(ngModel)]="pmEmail"
              [disabled]="isEdit"
              [readOnly]="isEdit"
            />
          </div>
        </div>
        <!-- PM Mobile -->
        <div class="col-md-4 col-12">
          <div class="column mx-4 my-2">
            <h5 class="medium-h">{{ "PM Mobile" | translator }}</h5>
            <input
              type="text"
              class="form-control ms-input"
              [placeholder]="'PM Mobile' | translator"
              id="pmMobileInput"
              aria-describedby="emailHelp"
              [(ngModel)]="pmMobile"
            />
          </div>
        </div>
        <div class="col-md-4 col-12">
          <div class="column mx-4 my-2">
            <h5 class="medium-h">{{ "Gender" | translator }}</h5>
            <p-dropdown
              optionValue="label"
              id="gender"
              [options]="gender"
              [placeholder]="
                isEdit ? selectedGender : ('Choose gender' | translator)
              "
              [(ngModel)]="selectedGender"
              styleClass=" sstarabic w-100"
            >
            </p-dropdown>
          </div>
        </div>
      </div>
      <ng-container *ngIf="showExtra">
        <!-- Alternative PM Details -->
        <div class="row my-4">
          <!-- Alternative PM Name -->
          <div class="col-md-4 col-12">
            <div class="column mx-4 my-2">
              <h5 class="medium-h">{{ "Alternative PM Name" | translator }}</h5>
              <input
                type="text"
                class="form-control ms-input"
                [placeholder]="'Alternative PM Name' | translator"
                id="altPmNameInput"
                aria-describedby="emailHelp"
                [(ngModel)]="altPmName"
              />
            </div>
          </div>
          <!-- Alternative PM Email -->
          <div class="col-md-4 col-12">
            <div class="column mx-4 my-2">
              <h5 class="medium-h">{{ "Alternative PM Email" | translator }}</h5>
              <input
                type="text"
                class="form-control ms-input"
                [placeholder]="'Alternative PM Email' | translator"
                id="altPmEmailInput"
                aria-describedby="emailHelp"
                [(ngModel)]="altPmEmail"
                [disabled]="isEdit"
                [readOnly]="isEdit"
              />
            </div>
          </div>
          <!-- Alternative PM Mobile -->
          <div class="col-md-4 col-12">
            <div class="column mx-4 my-2">
              <h5 class="medium-h">{{ "Alternative PM Mobile" | translator }}</h5>
              <input
                type="text"
                class="form-control ms-input"
                [placeholder]="'Alternative PM Mobile' | translator"
                id="altPmMobileInput"
                aria-describedby="emailHelp"
                [(ngModel)]="altPmMobile"
              />
            </div>
          </div>
        </div>
      </ng-container>
      <!-- Add a button to create the user -->
      <div class="d-flex justify-content-center gap-1">
        <button class="submmit-btn mb-3" (click)="isEdit ? createCompany() : checkVendor();">
          {{ (isEdit ? "Update" : "Create") | translator }}
        </button>
        <button *ngIf="isEdit" class="submmit-btn mb-3" (click)="cancelEdit()">
          {{ "Cancel" | translator }}
        </button>
      </div>
    </div>
    <div class="my-5">
      <h4 class="large-h mb-0">{{ "Vendor List" | translator }}</h4>
      <div *ngIf="vendors.length <= 0" class="mt-2">
        <app-no-data></app-no-data>
      </div>
      <ng-container *ngIf="vendors.length > 0">
        <div
          class="row flex-white-box-row-mob white-box-row"
          *ngFor="let vendor of vendors; let i = index"
        >
          <div class="col-md-3 col-12">
            <div class="d-flex align-items-center mob-w-100">
              <div>
                <div class="number-box">
                  {{ i + 1 }}
                </div>
              </div>
              <h5 class="medium-h-row">
                {{ vendor.name }}
              </h5>
            </div>
          </div>
          <div class="col-md-7 col-12">
            <div class="d-flex flex-wrap mob-m-t-b-1rem">
              <div
                class="detail-box"
              >
                <i class="pi pi-shield icon-ml"></i
                >{{
                  capitalizeFirstLetter(vendor.classification) | translator
                }}
              </div>
              <div
                *ngFor="let user of vendor.vendors; let j = index"
                class="detail-box"
              >
                <i class="fa-regular fa-envelope icon-ml"></i>
                {{ user.email }}
              </div>
            </div>
          </div>
          <div class="col-md-2 col-12">
            <div class="responsive-flex">
              <div
                class="circle-btn"
                (click)="deleteVendor(vendor._id, $event)"
              >
                <i class="fa fa-trash"></i>
              </div>
              <div class="circle-btn" (click)="loadVendor(vendor)">
                <i class="fa fa-pencil"></i>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</section>

<p-confirmDialog [style]="{ margin: '0rem 1rem' }"></p-confirmDialog>

<app-footer></app-footer>
